import { Box, styled } from '@mui/material';

export const Container = styled(Box)`
  flex: 1;
`;

export const InputContainer = styled(Box)`
  padding: 10px 20px;
`;
